import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import {
  rechartsAllData,
  rechartsAttendeeData,
  hidemytaskButton,
  setChartClickType
} from "../../redux/actions/actionAction/ActionAction";
import { getMeetingActionPriotityDetails } from "../../redux/actions/meetingActions/MeetingAction";
import { getUserActionPriotityDetails } from "../../redux/actions/actionAction/ActionAction";
import { Link } from "react-router-dom";
import NoDataFound from "../Common/NoDataFound";
import Alert from "../Common/Alert";
import * as constantMessages from "../../constants/constatntMessages";

const regularExpressionForSearch =
  /^[0-9a-zA-Z .,:\n;%@&#!$^*+=`~()/_'"\\\-?|{}()\[\]]+$/;
const MeetingBar = React.memo(({ showDetailsLink }) => {
  const accessToken = localStorage.getItem("accessToken");
  const employeeData = useSelector((state) => state.user);
  const meetingData = useSelector((state) => state.meeting);
  const actionData = useSelector((state) => state.action);
  const hideMyTaskButton = useSelector((state) => actionData.hidemyTaskButton);
  const authData = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(5);
  const [showUserData, setShowUserData] = useState(false);
  const [userData, setUserData] = useState([]);
  const [userPage, setUserPage] = useState(1);
  const [errors, setErrors] = useState({});
  ///////
  const [searchKey, setSearchKey] = useState("");

  const [debouncedQuery, setDebouncedQuery] = useState(searchKey);
  const prevDebouncedRef = useRef(debouncedQuery);
  const lastCardClickTypeRef = useRef(null);
  const [searchData, setSearchData] = useState({
    searchKey: "",
    page: 1,
    limit: 5,
    order: -1,
    filterData: {},
  });
  // Debounce effect
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(searchKey); // Triggers only after delay
    }, 800); // 800ms delay

    return () => {
      clearTimeout(handler); // Cleanup on input change
    };
  }, [searchKey]);

  useEffect(() => {
    if (debouncedQuery || (prevDebouncedRef.current && debouncedQuery === "")) {
      // Make API call or perform search

      const errors = {};
      if (searchKey !== "") {
        if (!regularExpressionForSearch.test(searchKey)) {
          errors.searchKey = constantMessages.titleRegexError;
          setErrors(errors);
        } else {
          if (showUserData) {
            const payload = {
              page: page,
              order: -1,
              limit: 5,
              organizationId: employeeData?.userData?.organizationId,
              searchKey,
            };

            dispatch(getUserActionPriotityDetails(payload, accessToken));
          } else {
            const payload = {
              page: page,
              order: -1,
              limit: 5,
              organizationId: employeeData?.userData?.organizationId,
              searchKey,
            };

            if (!authData.isInValidUser) {
              dispatch(getMeetingActionPriotityDetails(payload, accessToken));
            }
          }
          setErrors({});
        }
      } else {
        setErrors({});

        if (showUserData) {
          const payload = {
            page: page,
            order: -1,
            limit: 5,
            organizationId: employeeData?.userData?.organizationId,
            searchKey,
          };

          dispatch(getUserActionPriotityDetails(payload, accessToken));
        } else {
          const payload = {
            page: page,
            order: -1,
            limit: 5,
            organizationId: employeeData?.userData?.organizationId,
            searchKey,
          };

          if (!authData.isInValidUser) {
            dispatch(getMeetingActionPriotityDetails(payload, accessToken));
          }
        }
      }
    }
    prevDebouncedRef.current = debouncedQuery;
  }, [debouncedQuery]);

  useEffect(() => {
    if (employeeData?.userData?.organizationId) {
      const payload = {
        page,
        order: -1,
        limit,
        organizationId: employeeData?.userData?.organizationId,
      };
      if (!authData.isInValidUser) {
        dispatch(getMeetingActionPriotityDetails(payload, accessToken));
      }
    }
  }, [employeeData?.userData?.organizationId]);

  useEffect(() => {
    if (employeeData?.userData?.organizationId && meetingData?.createdById) {
      const payload = {
        page,
        order: -1,
        limit,
        organizationId: employeeData?.userData?.organizationId,
        createdById: meetingData?.createdById,
      };
      if (!authData.isInValidUser) {
        dispatch(getMeetingActionPriotityDetails(payload, accessToken));
      }
    }

    if (
      employeeData?.userData?.organizationId &&
      meetingData?.createdById === null
    ) {
      const payload = {
        page,
        order: -1,
        limit,
        organizationId: employeeData?.userData?.organizationId,
        //  createdById:meetingData?.createdById
      };
      if (!authData.isInValidUser) {
        dispatch(getMeetingActionPriotityDetails(payload, accessToken));
      }
    }
  }, [meetingData?.createdById]);

  useEffect(() => {
    if (employeeData?.userData?.organizationId) {
      const payload = {
        page,
        order: -1,
        limit,
        organizationId: employeeData?.userData?.organizationId,
      };

      dispatch(getUserActionPriotityDetails(payload, accessToken));
    }
  }, [showUserData]);

  useEffect(() => {
    if (meetingData?.meetingDueActionDetailsPriorityWise?.length !== 0) {
      const requiredFormat =
        meetingData?.meetingDueActionDetailsPriorityWise?.meetingsData?.map(
          (meeting) => {
            return {
              name:
                window.innerWidth <= 768
                  ? meeting?.meetingId?.slice(0, 3) + ".."
                  : meeting?.meetingId?.slice(0, 5) + "...",
              HighPriority: meeting?.totalHighPriorityDueAction,
              NormalPriority: meeting?.totalMediumPriorityDueAction,
              LowPriority: meeting?.totalLowPriorityDueAction,
              value: meeting,
              HighPriorityNotDelay:
                meeting?.totalHighPriorityDueActionNotDelayed,
              HighPriorityDelay: meeting?.totalHighPriorityDueActionDelayed,
              NormalPriorityDelay: meeting?.totalMediumPriorityDueActionDelayed,
              NormalPriorityNotDelay:
                meeting?.totalMediumPriorityDueActionNotDelayed,
              LowPriorityDelay: meeting?.totalLowPriorityDueActionDelayed,
              LowPriorityNotDelay: meeting?.totalLowPriorityDueActionNotDelayed,
            };
          }
        );

      if (Array.isArray(requiredFormat)) {
        setData([...requiredFormat]);
      }
    }
  }, [meetingData?.meetingDueActionDetailsPriorityWise]);

  useEffect(() => {
    if (actionData?.userDueActionDetailsPriorityWise?.length !== 0) {
      const requiredFormat =
        actionData?.userDueActionDetailsPriorityWise?.userDatas?.map(
          (meeting) => {
            return {
              name:
                window.innerWidth <= 768
                  ? meeting?.name?.slice(0, 3) + ".."
                  : meeting?.name?.slice(0, 5) + "...",
              HighPriority: meeting?.totalHighPriorityDueAction,
              NormalPriority: meeting?.totalMediumPriorityDueAction,
              LowPriority: meeting?.totalLowPriorityDueAction,
              value: meeting,
              HighPriorityNotDelay:
                meeting?.totalHighPriorityDueActionNotDelayed,
              HighPriorityDelay: meeting?.totalHighPriorityDueActionDelayed,
              NormalPriorityDelay: meeting?.totalMediumPriorityDueActionDelayed,
              NormalPriorityNotDelay:
                meeting?.totalMediumPriorityDueActionNotDelayed,
              LowPriorityDelay: meeting?.totalLowPriorityDueActionDelayed,
              LowPriorityNotDelay: meeting?.totalLowPriorityDueActionNotDelayed,
            };
          }
        );

      if (Array.isArray(requiredFormat)) {
        setUserData([...requiredFormat]);
      }
    }
  }, [actionData?.userDueActionDetailsPriorityWise]);

  const fetchNextData = () => {
    if (showUserData) {
      if (page > 0) {
        setPage(page + 1);
        const payload = {
          page: page + 1,
          order: -1,
          limit: 5,
          organizationId: employeeData?.userData?.organizationId,
          searchKey,
        };

        dispatch(getUserActionPriotityDetails(payload, accessToken));
      }
    } else {
      if (page > 0) {
        setPage(page + 1);
        const payload = {
          page: page + 1,
          order: -1,
          limit: 5,
          organizationId: employeeData?.userData?.organizationId,
          searchKey,
        };
        if (!authData.isInValidUser) {
          dispatch(getMeetingActionPriotityDetails(payload, accessToken));
        }
      }
    }
  };

  const fetchPreviousData = () => {
    if (showUserData) {
      if (page > 1) {
        setPage(page - 1);
        const payload = {
          page: page - 1,
          order: -1,
          limit: 5,
          organizationId: employeeData?.userData?.organizationId,
          searchKey,
        };

        dispatch(getUserActionPriotityDetails(payload, accessToken));
      }
    } else {
      if (page > 1) {
        setPage(page - 1);
        const payload = {
          page: page - 1,
          order: -1,
          limit: 5,
          organizationId: employeeData?.userData?.organizationId,
          searchKey,
        };
        if (!authData.isInValidUser) {
          dispatch(getMeetingActionPriotityDetails(payload, accessToken));
        }
      }
    }
  };

  const totalUserCount =
    actionData?.userDueActionDetailsPriorityWise?.totalCount;
  const checkUserTotalPage =
    totalUserCount % limit === 0
      ? Math.round(totalUserCount / limit)
      : Math.round(totalUserCount / limit + 0.5);
  const totalUserPage = totalUserCount ? checkUserTotalPage : 0;
  const totalUserPageArray = Array(totalUserPage).fill();

  const totalCount =
    meetingData?.meetingDueActionDetailsPriorityWise?.totalCount;
  const checkTotalPage =
    totalCount % limit === 0
      ? Math.round(totalCount / limit)
      : Math.round(totalCount / limit + 0.5);
  const totalPage = totalCount ? checkTotalPage : 0;
  const totalPageArray = Array(totalPage).fill();
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip bar-graph-tooltip">
          <p className="intro">{payload[0]?.payload?.value?.meetingId}</p>
          <p className="intro">{`Total : ${payload[0]?.payload?.value?.totalDueAction}`}</p>
          <hr className="divider" />
          <p className="label high-priority">{`High Priority (Due): ${payload[0]?.payload?.value?.totalHighPriorityDueAction}`}</p>

          <p className="label high-priority delay high-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalHighPriorityDueActionDelayed}`}</p>
          <p className="label high-priority high-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalHighPriorityDueActionNotDelayed}`}</p>
          <hr className="divider" />

          <p className="label Normal-priority">{`Normal Priority (Due): ${payload[0]?.payload?.value?.totalMediumPriorityDueAction}`}</p>

          <p className="label Normal-priority delay normal-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalMediumPriorityDueActionDelayed}`}</p>
          <p className="label Normal-priority normal-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalMediumPriorityDueActionNotDelayed}`}</p>
          <hr className="divider" />

          <p className="label low-priority">{`Low Priority (Due): ${payload[0]?.payload?.value?.totalLowPriorityDueAction}`}</p>
          <p className="label low-priority delay low-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalLowPriorityDueActionDelayed}`}</p>
          <p className="label low-priority low-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalLowPriorityDueActionNotDelayed}`}</p>
        </div>
      );
    }
    return null;
  };

  const CustomUserTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="custom-tooltip bar-graph-tooltip">
          <p className="intro">{payload[0]?.payload?.value?.name}</p>
          <p className="intro">({payload[0]?.payload?.value?.email})</p>
          <p className="intro">{`Total : ${payload[0]?.payload?.value?.pendingActions}`}</p>
          <hr className="divider" />
          <p className="label high-priority">{`High Priority (Due): ${payload[0]?.payload?.value?.totalHighPriorityDueAction}`}</p>

          <p className="label high-priority delay high-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalHighPriorityDueActionDelayed}`}</p>
          <p className="label high-priority high-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalHighPriorityDueActionNotDelayed}`}</p>
          <hr className="divider" />

          <p className="label Normal-priority">
            {`Normal Priority (Due): ${payload[0]?.payload?.value?.totalMediumPriorityDueAction}`}{" "}
          </p>

          <p className="label Normal-priority delay normal-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalMediumPriorityDueActionDelayed}`}</p>
          <p className="label Normal-priority normal-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalMediumPriorityDueActionNotDelayed}`}</p>
          <hr className="divider" />

          <p className="label low-priority">{`Low Priority: (Due): ${payload[0]?.payload?.value?.totalLowPriorityDueAction}`}</p>

          <p className="label low-priority delay low-priority-dark">{`Delay: ${payload[0]?.payload?.value?.totalLowPriorityDueActionDelayed}`}</p>
          <p className="label low-priority low-priority-light">{`Not Delay: ${payload[0]?.payload?.value?.totalLowPriorityDueActionNotDelayed}`}</p>
        </div>
      );
    }
    return null;
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchKey(value);
  };

  const setAll = (e) => {
    setShowUserData(false);
    setPage(1);
  };

  const setUser = (e) => {
    setShowUserData(true);
    setPage(1);
  };
  const CustomLegend = () => (
    <div
      className="recharts-legend-wrapper"
      style={{ padding: 0, margin: 0, textAlign: "center" }}
    >
      <ul
        style={{
          display: "flex",
          listStyle: "none",
          padding: "7px 0px 3px 43px",
          margin: "3px",
        }}
      >
        <li
          className="recharts-legend-item"
          style={{ display: "inline-block", marginRight: 10 }}
        >
          <span
            style={{
              color: "rgb(255, 89, 89)",
              width: 10,
              height: 10,
              backgroundColor: "#ff5959",
              display: "inline-block",
              marginRight: 10,
            }}
          ></span>
          High Priority
        </li>
        <li
          className="recharts-legend-item"
          style={{ display: "inline-block", marginRight: 10 }}
        >
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              backgroundColor: "#186fef",
              marginRight: 5,
            }}
          ></span>
          Normal Priority
        </li>
        <li
          className="recharts-legend-item"
          style={{ display: "inline-block", marginRight: 10 }}
        >
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              backgroundColor: "#35c654",
              marginRight: 5,
            }}
          ></span>
          Low Priority
        </li>
      </ul>
    </div>
  );
  const handleChartClickforall = async (data) => {
       dispatch(setChartClickType(false));
    setSearchData({ ...searchData, page: 1 });

    dispatch(hidemytaskButton(true));
    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (data?.activePayload?.length > 0) {
      const clickedMeeting = data.activePayload[0]?.payload?.value;
      if (clickedMeeting?.meetingId) {
      
        const payload = {
          limit: searchData.limit || 10,
          // page: searchData.page || 1,
            page: 1,
          order: 1,
          organizationId: employeeData?.userData?.organizationId.trim(),
          meetingId: clickedMeeting.meetingId,
          tableSection: tableSection,
        };
    
       await dispatch(rechartsAllData(payload, accessToken));
       dispatch(setChartClickType(true));
      } else {
        console.log("Meeting ID is missing!");
      }
    } else {
      console.log("No activePayload found!", data);
    }
  };

  const handleChartClickforattendee = async (data) => {
   // alert("handleChartClickforattendee")
     dispatch(setChartClickType(false));
    setSearchData({ ...searchData, page: 1 });


    dispatch(hidemytaskButton(true));
    const tableSection = document.getElementById("table-section");
    if (tableSection) {
      tableSection.scrollIntoView({ behavior: "smooth", block: "start" });
    }
    if (data?.activePayload?.length > 0) {
      const clickedMeeting = data.activePayload[0]?.payload?.value;
      const paginationassignedUserId =
        data.activePayload[0]?.payload?.value?.assignedUserId;
      if (clickedMeeting?.assignedUserId) {
        const payload = {
          limit: searchData.limit || 10,
          // page: searchData.page || 1,
            page: 1,
          order: 1,
          organizationId: employeeData?.userData?.organizationId.trim(),
          assignedUserId:
            paginationassignedUserId || clickedMeeting.assignedUserId,
          tableSection: tableSection,
        };
        await dispatch(rechartsAttendeeData(payload, accessToken));
   dispatch(setChartClickType(true));
      } else {
        console.log("Meeting ID is missing!");
      }
    } else {
      console.log("No activePayload found!", data);
    }
  };
  return (
    <div className="resp-bar-chart">
      <div className="title-next-prev d-flex align-items-center justify-content-between ">
        <h6 className="mb-0">Due Actions</h6>
        {employeeData?.userData?.isEmployee ? (
          <div className="graph-btn d-flex align-items-center all-attendee-btns">
            <button
              onClick={() => setAll()}
              className={
                showUserData
                  ? "badge disable-btn me-2 all-btn padding-btnall"
                  : "badge newbtn-color me-2 all-btn padding-btnall"
              }
            >
              All
            </button>
            <button
              onClick={() => setUser()}
              className={
                !showUserData
                  ? "badge disable-btn all-btn padding-btnall"
                  : "badge newbtn-color all-btn padding-btnall"
              }
            >
              Attendees
            </button>
          </div>
        ) : null}
      </div>

      <div className="search-div">
        <div className="w-resp">
          <div className="search-box search-id mb-2">
            <input
              type="search"
              placeholder="Search By Meeting Title / ID"
              onChange={handleChange}
              name="searchKey"
              value={searchKey}
              autoComplete="off"
            />
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="#4F2CC8"
              className="bi bi-search"
              viewBox="0 0 16 16"
            >
              <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001q.044.06.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1 1 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0" />
            </svg>
          </div>
          {errors?.searchKey && (
            <span className="error-message">{errors?.searchKey}</span>
          )}
        </div>
      </div>

      {meetingData?.meetingDueActionDetailsPriorityWise?.totalCount === 0 ? (
        <div className="no-data-img mt-3">
          <Alert
            status={"info"}
            message={"No due action found."}
            timeoutSeconds={0}
          />
          <NoDataFound dataType={"meeting"} width={350} />
        </div>
      ) : (
        <>
          {showUserData ? (
            <>
              <ResponsiveContainer
                width="100%"
                height={355}
                className="bar-graph"
              >
                <BarChart
                  cursor="pointer"
                  width={650}
                  height={330}
                  data={userData}
                  onClick={handleChartClickforattendee}
                  margin={{ top: 15, right: 0, left: 0, bottom: 0 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis yAxisId="left" orientation="left" stroke="black" />

                  <Tooltip
                    content={<CustomUserTooltip />}
                    wrapperStyle={{ outline: "none" }}
                    contentStyle={{
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                    }}
                    itemStyle={{ color: "#333" }}
                    cursor={false}
                  />
                  <Legend content={<CustomLegend />} />

                  {/* High Priority stacked */}
                  <Bar
                    yAxisId="left"
                    dataKey="HighPriorityDelay"
                    stackId="high"
                    fill="#ff5959"
                    name="High Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="HighPriorityNotDelay"
                    stackId="high"
                    fill="#ffb3b3"
                    name="High Priority Not Delay"
                  />

                  {/* Normal Priority stacked */}

                  <Bar
                    yAxisId="left"
                    dataKey="NormalPriorityDelay"
                    stackId="normal"
                    fill="#186fef"
                    name="Normal Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="NormalPriorityNotDelay"
                    stackId="normal"
                    fill="#a3bfff"
                    name="Normal Priority Not Delay"
                  />

                  {/* Low Priority stacked */}

                  <Bar
                    yAxisId="left"
                    dataKey="LowPriorityDelay"
                    stackId="low"
                    fill="#35c654"
                    name="Low Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="LowPriorityNotDelay"
                    stackId="low"
                    fill="#b7e5b7"
                    name="Low Priority Not Delay"
                  />
                </BarChart>
              </ResponsiveContainer>
            </>
          ) : (
            <>
              <ResponsiveContainer
                width="100%"
                height={355}
                className="bar-graph"
              >
                <BarChart
                  cursor="pointer"
                  width={650}
                  height={330}
                  onClick={handleChartClickforall}
                  data={data}
                  cursor="pointer"
                  margin={{ top: 15, right: 0, left: 0, bottom: 0 }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis yAxisId="left" orientation="left" stroke="black" />
                  <Tooltip
                    content={<CustomTooltip />}
                    wrapperStyle={{ outline: "none" }}
                    contentStyle={{
                      backgroundColor: "white",
                      border: "1px solid #ccc",
                    }}
                    itemStyle={{ color: "#333" }}
                    cursor={false}
                  />
                  <Legend content={<CustomLegend />} />

                  {/* High Priority stacked */}
                  <Bar
                    yAxisId="left"
                    dataKey="HighPriorityDelay"
                    stackId="high"
                    fill="#ff5959"
                    name="High Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="HighPriorityNotDelay"
                    stackId="high"
                    fill="#ffb3b3"
                    name="High Priority Not Delay"
                  />

                  {/* Normal Priority stacked */}

                  <Bar
                    yAxisId="left"
                    dataKey="NormalPriorityDelay"
                    stackId="normal"
                    fill="#186fef"
                    name="Normal Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="NormalPriorityNotDelay"
                    stackId="normal"
                    fill="#a3bfff"
                    name="Normal Priority Not Delay"
                  />

                  {/* Low Priority stacked */}

                  <Bar
                    yAxisId="left"
                    dataKey="LowPriorityDelay"
                    stackId="low"
                    fill="#35c654"
                    name="Low Priority Delay"
                  />
                  <Bar
                    yAxisId="left"
                    dataKey="LowPriorityNotDelay"
                    stackId="low"
                    fill="#b7e5b7"
                    name="Low Priority Not Delay"
                  />
                </BarChart>
              </ResponsiveContainer>
            </>
          )}
        </>
      )}

      <div className="statistics-data next-prev-details">
        {showDetailsLink && data?.length !== 0 && (
          <Link
            to="/action-list"
            className="badge bg-opacity-10 scheduled-color view-details-btn"
            style={{
              textDecoration: "none",
              lineHeight: "13px",
            }}
          >
            View Action Details
          </Link>
        )}
        {actionData?.userDueActionDetailsPriorityWise?.totalCount !== 0 ? (
          <div className="next-prev-button next-prev-button-new ">
            {page !== 1 ? (
              <button
                className="left-arrow"
                onClick={() => fetchPreviousData()}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#fff"
                  className="bi bi-chevron-left"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
                  />
                </svg>
              </button>
            ) : null}

            {!showUserData &&
            totalPageArray?.length !== page &&
            data?.length !== 0 ? (
              <button className="right-arrow" onClick={() => fetchNextData()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#fff"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </button>
            ) : null}
            {showUserData &&
            totalUserPageArray?.length !== page &&
            data?.length !== 0 ? (
              <button className="right-arrow" onClick={() => fetchNextData()}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="#fff"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill-rule="evenodd"
                    d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
                  />
                </svg>
              </button>
            ) : null}
          </div>
        ) : null}
      </div>
    </div>
  );
});

export default MeetingBar;
